import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function LatestNews() {
  const latestArticles = articles.filter((a) => a.featured).slice(0, 3);

  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <p className="text-xs md:text-sm text-primary-600 font-medium tracking-wide uppercase mb-2">
              最新动态
            </p>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              热门资讯
            </h2>
          </div>
          <Link
            to="/category/news"
            className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group block bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-primary-500 text-background-50 text-xs rounded-full font-medium">
                    {article.categoryName}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-3">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 line-clamp-2 mb-4 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{article.date}</span>
                  <span>{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}